/**
 * General
 */
export const DEG_TO_RAD = 0.017453293;
export const PACKAGE_NAME = "org.maddoofy.madvolley";
export const SLASH = "/";
export const FIXED_FRAME_RATE = 32;
export const TARGET_DENSITY = 160;
export const DENSITY_SCALE = 90 / TARGET_DENSITY;
export const NUM_INPUT_EVENTS = 5;
export const NUM_DELAYED_EVENTS = 20;
export const LOG_TAG = PACKAGE_NAME;

/**
 * Options
 */
export const OPTION_BACK = 1001;
export const OPTION_DEBUG = 1002;
export const OPTION_RESET = 1003;
export const OPTION_PAUSE = 1004;
export const OPTION_RESUME = 1005;
export const OPTION_SETTINGS = 1006;
export const OPTION_MENU = 1007;

/**
 * Logic states
 */
export const LOGIC_MENU_SPLASH = 2101;
export const LOGIC_MENU_RUNNING = 2102;
export const LOGIC_MENU_GAME_LAUNCHING = 2103;

export const LOGIC_GAME_INTRO = 2201;
export const LOGIC_GAME_KICKOFF = 2202;
export const LOGIC_GAME_RUNNING = 2203;
export const LOGIC_GAME_POST = 2205;
export const LOGIC_GAME_FINISHED = 2206;

/**
 * Input event types
 */
export const INPUT_KEY_EVENT = 4001;
export const INPUT_MOTION_EVENT = 4002;

/**
 * Actions
 */
export const NO_ACTION = -1;

/**
 * Events
 */
export const NO_EVENT = -1;
export const EVENTS_ALL = 0xffff;

export const EVENTS_ENGINE = 0x100;
export const EVENT_ENGINE_PRE_START = EVENTS_ENGINE + 1;
export const EVENT_ENGINE_POST_START = EVENTS_ENGINE + 2;
export const EVENT_ENGINE_PRE_STOP = EVENTS_ENGINE + 3;
export const EVENT_ENGINE_POST_STOP = EVENTS_ENGINE + 4;
export const EVENT_ENGINE_VIEWPORT_CHANGED = EVENTS_ENGINE + 5;

export const EVENTS_GAME = 0x200;
export const EVENT_GAME_RESET = EVENTS_GAME + 1;
export const EVENT_GAME_PAUSE = EVENTS_GAME + 2;
export const EVENT_GAME_RESUME = EVENTS_GAME + 3;
export const EVENT_GAME_QUIT = EVENTS_GAME + 4;
export const EVENT_GAME_SHARE = EVENTS_GAME + 5;

export const EVENTS_INGAME = 0x400;
export const EVENT_INGAME_KICKOFF = EVENTS_INGAME + 1;
export const EVENT_INGAME_PLAYER_HITS_BALL = EVENTS_INGAME + 2;
export const EVENT_INGAME_PLAYER_HITS_GROUND = EVENTS_INGAME + 3;
export const EVENT_INGAME_PLAYER_JUMPS = EVENTS_INGAME + 4;
export const EVENT_INGAME_BALL_HITS_GROUND = EVENTS_INGAME + 5;
export const EVENT_INGAME_BALL_HITS_NET = EVENTS_INGAME + 6;
export const EVENT_INGAME_NEXT_ROUND = EVENTS_INGAME + 7;
export const EVENT_INGAME_SCORE_UPDATED = EVENTS_INGAME + 8;
export const EVENT_INGAME_HURRY_UP = EVENTS_INGAME + 9;
export const EVENT_INGAME_EXPLOSION = EVENTS_INGAME + 10;
export const EVENT_INGAME_FINISHED = EVENTS_INGAME + 11;
export const EVENT_INGAME_FOUL = EVENTS_INGAME + 12;
export const EVENT_INGAME_MATCHBALL = EVENTS_INGAME + 13;
export const EVENT_INGAME_PLAYER_HITS_BALL_MAXIMUM = EVENTS_INGAME + 14;
export const EVENT_INGAME_TROPHY_ACHIEVED = EVENTS_INGAME + 15;

export const EVENT_INGAME_TUTORIAL_NEXTSTEP = EVENTS_INGAME + 50;
export const EVENT_INGAME_TUTORIAL_FINISHED = EVENTS_INGAME + 51;

export const EVENTS_MENU = 0x800;
export const EVENT_MENU_START = EVENTS_MENU + 1;
export const EVENT_MENU_BACK = EVENTS_MENU + 2;
export const EVENT_MENU_MENU_PRESSED = EVENTS_MENU + 3;

/**
 * Game
 */
export const NO_PLAYER = -1;
export const PLAYER_1 = 0;
export const PLAYER_2 = 1;
export const INSIDE = 0;
export const OUTSIDE = 1;
export const NO_TUTORIAL_STEP = -1;

/**
 * Menu
 */
export const MENU_COMMAND_QUICKSTART = 1;
export const MENU_COMMAND_START_GAME = 2;
export const MENU_COMMAND_CHOOSE_LEVEL = 3;
export const MENU_COMMAND_CHOOSE_CHARACTER = 4;
export const MENU_COMMAND_CHOOSE_GAME_TYPE = 5;
export const MENU_COMMAND_SETTINGS = 6;
export const MENU_COMMAND_START_TROPHIES = 7;
export const MENU_COMMAND_SWITCH_TROPHY_VIEW = 8;
export const MENU_COMMAND_BUY_FULL_VERSION = 9;

/**
 * Intent actions
 */
export const INTENT_ACTION_GAME = PACKAGE_NAME + ".GAME";
export const INTENT_ACTION_SETTINGS = PACKAGE_NAME + ".SETTINGS";
export const INTENT_ACTION_GRAPHICS_QUALITY = PACKAGE_NAME + ".GRAPHISC_QUALITY";
export const INTENT_EXTRAS_GAME = "game";
export const INTENT_EXTRAS_RECOMMENDED_GQ = "recommendedGraphicsQuality";
export const INTENT_REQUESTCODE_GRAPHICS_QUALITY = 8401;

/**
 * Menu styles
 */
export const MENU_STYLE_LIST = 0;
export const MENU_STYLE_GALLERY = 1;

/**
 * Preferences
 */
export const PREFERENCE_DIFFICULTY = "difficulty";
export const PREFERENCE_SOUND = "sound";
export const PREFERENCE_MUSIC = "music";
export const PREFERENCE_TUTORIAL = "tutorial";
export const PREFERENCE_GRAPHICS = "graphics";
export const PREFERENCE_JUMP_SENSIBILITY = "jumpSensibility";

export const PREFERENCE_MENU_LEVEL_TRANSLATE = "menu.level.translate";
export const PREFERENCE_MENU_CHARACTER_TRANSLATE = "menu.character.translate";
export const PREFERENCE_MENU_GAMETYPE_TRANSLATE = "menu.gametype.translate";

export const PREFERENCE_DIFFICULTY_EASY = "EASY";
export const PREFERENCE_DIFFICULTY_MEDIUM = "MEDIUM";
export const PREFERENCE_DIFFICULTY_HARD = "HARD";
export const PREFERENCE_GRAPHICS_HIGH = "HIGH";
export const PREFERENCE_GRAPHICS_MEDIUM = "MEDIUM";
export const PREFERENCE_GRAPHICS_LOW = "LOW";
export const PREFERENCE_JUMP_SENSIBILITY_HIGH = "HIGH";
export const PREFERENCE_JUMP_SENSIBILITY_MEDIUM = "MEDIUM";
export const PREFERENCE_JUMP_SENSIBILITY_LOW = "LOW";

/**
 * Game types
 */
export const GAMETYPE_NONE = 0;
export const GAMETYPE_BEST_OF = 1;
export const GAMETYPE_TIME = 2;
export const GAMETYPE_BOMB = 3;

/**
 * Game difficulty
 */
export const DIFFICULTY_EASY = 1;
export const DIFFICULTY_MEDIUM = 2;
export const DIFFICULTY_HARD = 3;

/**
 * Graphics quality
 */
export const GRAPHICS_LOW = 1;
export const GRAPHICS_MEDIUM = 2;
export const GRAPHICS_HIGH = 3;

/**
 * Difficulties
 */

/**
 * Ball types
 */
export const BALL_TYPE_DEFAULT = 0;
export const BALL_TYPE_BOMB = 1;

/**
 * Entity states
 */
export const ENTITY_STATE_DEFAULT = 0;
export const ENTITY_STATE_EXPLODING = 1;
export const ENTITY_STATE_CHARRED = 2;

/**
 * Trophy materials
 */
export const TROPHY_MATERIAL_NONE = 0;
export const TROPHY_MATERIAL_BRONZE = 1;
export const TROPHY_MATERIAL_SILVER = 2;
export const TROPHY_MATERIAL_GOLD = 3;

/**
 * Stats keys
 */
export const STATS_KEY_WINNING_STREAK = "stats.winning.%d.%d";
export const STATS_KEY_WHITEWASH_STREAK = "stats.whitewash.%d";
